/* PhotoHouse unified visible media geometry.
   Physical image pixels are NOT necessarily img.getBoundingClientRect(): in
   ordinary Shopify/Kingdom galleries (notably books), a wide image element
   may render a narrow right-aligned square via object-fit:contain. Frame
   products instead have real square stage elements. The visible photo is the
   single authority for both thumbnail and zoom placement. */
(function(){
  'use strict';
  window.phV7VisiblePhoto=function(article){
    var main=article.querySelector('.ctm_product_gallery_main');
    var gallery=article.querySelector('.product__gallery');
    if(!main||!gallery)return null;
    var outer=gallery.getBoundingClientRect();
    if(outer.width<80||outer.height<80)return null;
    var stages=[
      ['ph-auto-frame-active','[data-ph-auto-stage]'],
      ['ph-preview-has-selected-media','[data-ph-selected-frame-media-stage]'],
      ['ph-gift-media-active','[data-ph-gift-media-stage]']
    ];
    for(var si=0;si<stages.length;si++){
      var kind=stages[si];
      if(!article.classList.contains(kind[0]))continue;
      var stage=main.querySelector(kind[1]);
      if(stage&&!stage.hidden){
        var stageRect=stage.getBoundingClientRect();
        if(stageRect.width>60&&stageRect.height>60){
          return {rect:stageRect,element:stage,stage:true,mediaId:null};
        }
      }
    }
    function visible(el){
      for(var parent=el;parent&&parent!==article;parent=parent.parentElement){
        if(parent.hidden)return false;
        var st=window.getComputedStyle(parent);
        if(st.display==='none'||st.visibility==='hidden'||parseFloat(st.opacity)===0)return false;
      }
      return true;
    }
    function pos(value,free,vertical){
      var text=String(value||'').toLowerCase().trim();
      if(text==='left'||text==='top')return 0;
      if(text==='right'||text==='bottom')return free;
      if(text==='center'||text==='')return free/2;
      if(text.indexOf('%')!==-1){
        var percentage=parseFloat(text);
        return Number.isFinite(percentage)?free*percentage/100:free/2;
      }
      if(text.indexOf('px')!==-1){
        var n=parseFloat(text);
        return Number.isFinite(n)?n:free/2;
      }
      return free/2;
    }
    // Measure the image object PAINT, not the possibly letterboxed <img> box.
    // Preserve the computed object-position, including physical right alignment
    // under RTL. On actual-sized <img>, this returns the unchanged image rect.
    function pixels(img){
      var r=img.getBoundingClientRect();
      var style=window.getComputedStyle(img);
      var fit=style.objectFit||'fill';
      if(fit!=='contain'&&fit!=='scale-down')return r;
      var nw=img.naturalWidth,nh=img.naturalHeight;
      if(!nw||!nh||r.width<1||r.height<1)return r;
      var factor=Math.min(r.width/nw,r.height/nh);
      if(fit==='scale-down')factor=Math.min(1,factor);
      var w=nw*factor,h=nh*factor;
      var freeX=Math.max(0,r.width-w),freeY=Math.max(0,r.height-h);
      var tokens=String(style.objectPosition||'50% 50%').trim().split(/\s+/);
      var x=tokens[0]||'50%',y=tokens[1]||'50%';
      if(tokens.length===1){
        if(x==='top'||x==='bottom'){y=x;x='50%';}
        else y='50%';
      }
      // Accept CSS's common two-keyword vertical/horizontal order as well.
      if((x==='top'||x==='bottom')&&(y==='left'||y==='right')){
        var temp=x;x=y;y=temp;
      }
      var left=r.left+pos(x,freeX,false),top=r.top+pos(y,freeY,true);
      return {left:left,top:top,right:left+w,bottom:top+h,width:w,height:h};
    }
    function overlap(r){
      return Math.max(0,Math.min(outer.right,r.right)-Math.max(outer.left,r.left))*
        Math.max(0,Math.min(outer.bottom,r.bottom)-Math.max(outer.top,r.top));
    }
    function hitCount(img,cell,r){
      if(!document.elementFromPoint)return 0;
      var l=Math.max(0,outer.left,r.left),right=Math.min(window.innerWidth,outer.right,r.right);
      var top=Math.max(0,outer.top,r.top),bottom=Math.min(window.innerHeight,outer.bottom,r.bottom);
      if(right-l<30||bottom-top<30)return 0;
      var xs=[.22,.5,.78],ys=[.22,.55,.78],hits=0;
      for(var i=0;i<xs.length;i++)for(var j=0;j<ys.length;j++){
        var target=document.elementFromPoint(l+(right-l)*xs[i],top+(bottom-top)*ys[j]);
        if(target&&(target===img||img.contains(target)||
          (cell&&target.closest&&target.closest('.product-gallery__item')===cell)))hits++;
      }
      return hits;
    }
    var candidates=[];
    function scan(root,filtered){
      if(!root)return;
      Array.prototype.forEach.call(root.querySelectorAll('img'),function(img){
        if(!img.complete||img.naturalWidth<1||!visible(img))return;
        var photoRect=pixels(img);
        if(photoRect.width<60||photoRect.height<60||overlap(photoRect)<2500)return;
        var cell=img.closest('.product-gallery__item');
        if(cell&&cell.classList.contains('remove-from-flick'))return;
        var paintHits=hitCount(img,cell,photoRect);
        var score=(paintHits?100000000+paintHits*1000000:0)+
          (filtered?100000:0)+
          (cell&&cell.classList.contains('is-selected')?10000:0)+
          Math.min(9000,overlap(photoRect)/100);
        candidates.push({rect:photoRect,element:img,stage:false,
          mediaId:cell&&cell.getAttribute('data-media-id')||null,score:score});
      });
    }
    scan(main.querySelector('.filter_product_gallery'),true);
    scan(article.querySelector('.ctm_product-gallery'),false);
    if(!candidates.length)return null;
    candidates.sort(function(a,b){return b.score-a.score});
    var best=candidates[0];
    return{rect:best.rect,element:best.element,stage:false,mediaId:best.mediaId};
  };
}());

/* PhotoHouse V7: product layout + existing media thumbnails + same-page size chart.
   No add-to-cart calls, variant changes, price changes or Shopify API requests. */
(function(){
 'use strict';
 var desktop=window.matchMedia('(min-width:1024px)');
 function each(root,selector){return Array.prototype.slice.call(root.querySelectorAll(selector));}
 function byId(root,id){return root.querySelector('[data-media-id="'+String(id).replace(/[^0-9]/g,'')+'"]');}
 function initRail(article){
   if(article.dataset.phV7RailMounted==='1')return;
   var rail=article.querySelector('[data-ph-v7-rail]');
   var gallerySection=article.querySelector('.product__gallery');
   var galleryArea=article.querySelector('.ctm_product_gallery_main .filter_product_gallery');
   if(!rail||!gallerySection||!galleryArea)return;
   article.dataset.phV7RailMounted='1';
   var buttons=each(rail,'[data-ph-v7-thumb]');
   var activeGallery=null, frame=0, pendingMediaId=null;
   var track=rail.querySelector('[data-ph-v7-rail-track]');
   var prev=rail.querySelector('[data-ph-v7-prev]');
   var next=rail.querySelector('[data-ph-v7-next]');
   if(!track||!prev||!next)return;
   function syncArrows(){
     var canScroll=rail.classList.contains('is-ready')&&track.scrollWidth>track.clientWidth+3;
     prev.hidden=!canScroll;
     next.hidden=!canScroll;
     if(canScroll){
       prev.disabled=track.scrollLeft<=3;
       next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-3;
     }
   }
   function scrollThumbs(dir){
     var thumb=track.querySelector('.ph-v7__thumb:not([hidden])');
     var width=thumb?thumb.getBoundingClientRect().width:56;
     track.scrollBy({left:dir*(width+8)*3,behavior:'smooth'});
   }
   prev.addEventListener('click',function(){scrollThumbs(-1)});
   next.addEventListener('click',function(){scrollThumbs(1)});
   track.addEventListener('scroll',syncArrows,{passive:true});
   function galleryCells(gallery){return each(gallery,'.product-gallery__item[data-media-id]');}
   function currentGallery(){
     var filtered=galleryArea.querySelector('.custom_product_gallery');
     var original=article.querySelector('.ctm_product-gallery');
     var visiblePhoto=window.phV7VisiblePhoto&&window.phV7VisiblePhoto(article);
     var el=visiblePhoto&&visiblePhoto.element;
     var owner=el&&el.closest&&el.closest('.custom_product_gallery,.ctm_product-gallery');
     if(owner&&(owner===original||galleryArea.contains(owner)))return owner;
     return filtered||original;
   }
   function repaint(){
     frame=0;
     // Product media is re-filtered/rebuilt whenever a new variant is chosen.
     // Do not throw away the independently rendered thumbnail strip just
     // because Kingdom temporarily removes its carousel nodes.
     var gallery=currentGallery();
     var cells=gallery?galleryCells(gallery):[];
     buttons.forEach(function(button){button.hidden=false;});
     var enabled=desktop.matches&&buttons.length>1;
     rail.classList.toggle('is-ready',enabled);
     gallerySection.classList.toggle('ph-v7--with-rail',enabled);
     if(pendingMediaId&&cells.length){
       var requested=cells.findIndex(function(cell){return cell.getAttribute('data-media-id')===pendingMediaId;});
       if(requested>=0){
         var newFlickity=window.Flickity&&typeof window.Flickity.data==='function'&&window.Flickity.data(gallery);
         pendingMediaId=null;
         if(newFlickity&&typeof newFlickity.select==='function')newFlickity.select(requested);
       }
     }
     var selected=cells.find(function(cell){return cell.classList.contains('is-selected')})||cells[0]||null;
     if(enabled){
      var active=window.phV7VisiblePhoto&&window.phV7VisiblePhoto(article);
      var outer=gallerySection.getBoundingClientRect();
      if(active&&active.rect&&outer.width>100){
        var offset=Math.max(0,Math.min(outer.width-60,active.rect.left-outer.left));
        var width=Math.max(60,Math.min(465,active.rect.width,outer.width-offset));
        var px=Math.round(offset)+'px',span=Math.round(width)+'px';
        // The rail now uses the same photo coordinates as the magnifier.
        // Never translate an independently centered/RTL strip: other theme
        // styles would reset that coordinate system on rerender.
        rail.style.setProperty('direction','ltr','important');
        // A column flexbox centers a child when inline auto margins
        // remain present. In RTL, cross-axis flex-start is PHYSICAL RIGHT.
        // Fix its zero point to the physical gallery LEFT, then offset from
        // the actual painted image. Unlike margins, relative left cannot be
        // reinterpreted or distributed by the flex algorithm.
        var rtl=window.getComputedStyle(gallerySection).direction==='rtl';
        rail.style.setProperty('position','relative','important');
        rail.style.setProperty('align-self',rtl?'flex-end':'flex-start','important');
        rail.style.setProperty('left',px,'important');
        rail.style.setProperty('right','auto','important');
        rail.style.setProperty('transform','none','important');
        rail.style.setProperty('margin','10px 0 14px 0','important');
        rail.style.setProperty('margin-inline-start','0','important');
        rail.style.setProperty('margin-inline-end','0','important');
        rail.style.setProperty('padding','0','important');
        rail.style.setProperty('width',span,'important');
        rail.style.setProperty('--ph-qa-rail-width',span);
        rail.style.setProperty('visibility','visible','important');
      }else{
        rail.style.setProperty('visibility','hidden','important');
      }
    }
    var canonicalThumb=article.classList.contains('ph-gift-media-active')
       ? buttons.find(function(btn){return btn.getAttribute('data-ph-gift-media-selected')==='true';})
       : (article.classList.contains('ph-preview-has-selected-media')
         ? buttons.find(function(btn){return btn.getAttribute('data-ph-selected-frame-media')==='true';})
         : null);
     var visibleMedia=window.phV7VisiblePhoto&&window.phV7VisiblePhoto(article);
     var visibleMediaId=visibleMedia&&!visibleMedia.stage&&visibleMedia.mediaId;
     buttons.forEach(function(button){
       var mediaId=visibleMediaId||(selected&&selected.getAttribute('data-media-id'));
       var nativeSelected=mediaId===button.getAttribute('data-ph-v7-thumb');
       var active=!button.hidden&&(canonicalThumb?button===canonicalThumb:nativeSelected);
       button.classList.toggle('is-selected',Boolean(active));
       button.setAttribute('aria-pressed',String(Boolean(active)));
     });
     if(enabled && gallery && gallery!==activeGallery){
       activeGallery=gallery;
       // Give the existing Flickity instance its newly reduced available width.
       window.requestAnimationFrame(function(){
         if(!gallery.isConnected)return;
         if(window.Flickity&&typeof window.Flickity.data==='function'){
           var instance=window.Flickity.data(gallery);
           if(instance)instance.resize();
         }
       });
     }
     window.requestAnimationFrame(syncArrows);
   }
   function requestRepaint(){if(!frame)frame=window.requestAnimationFrame(repaint);}
   function frameKey(value){
     var s=String(value||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
     if(/printing only|print only|no frame|without frame|unframed|ללא מסגרת|הדפסה בלבד|הדפס בלבד/.test(s))return 'print';
     if(/black|שחור/.test(s))return 'black';
     if(/wenge|וונגה|ונגה/.test(s))return 'wenge';
     if(/amber|ענבר/.test(s))return 'amber';
     return '';
   }
   var previewDialog=null,previewImage=null,previewClose=null,previewReturn=null;
   function openOriginalPreview(button){
     var src=button.getAttribute('data-ph-v7-full');
     if(!src||typeof HTMLDialogElement==='undefined'||typeof HTMLDialogElement.prototype.showModal!=='function')return;
     if(!previewDialog){
       previewDialog=document.createElement('dialog');
       previewDialog.className='ph-qa-media-dialog';
       previewDialog.setAttribute('aria-label',/^he/i.test(document.documentElement.lang||'')?'תצוגת תמונת המוצר':'Product image preview');
       previewClose=document.createElement('button');
       previewClose.type='button';
       previewClose.className='ph-qa-media-close';
       previewClose.setAttribute('aria-label',/^he/i.test(document.documentElement.lang||'')?'סגירה':'Close');
       previewClose.textContent='×';
       previewImage=document.createElement('img');
       previewImage.className='ph-qa-media-image';
       previewDialog.appendChild(previewClose);
       previewDialog.appendChild(previewImage);
       document.body.appendChild(previewDialog);
       previewClose.addEventListener('click',function(){previewDialog.close()});
       previewDialog.addEventListener('click',function(event){if(event.target===previewDialog)previewDialog.close()});
       previewDialog.addEventListener('close',function(){if(previewReturn&&previewReturn.isConnected)previewReturn.focus()});
     }
     previewReturn=button;
     previewImage.alt=(button.querySelector('img')||{}).alt||'';
     previewImage.src=src;
     if(!previewDialog.open)previewDialog.showModal();
     previewClose.focus();
   }
   buttons.forEach(function(button){
     button.addEventListener('click',function(){
       var gallery=currentGallery();
       if(!gallery)return;
       var mediaId=button.getAttribute('data-ph-v7-thumb');
       var cells=galleryCells(gallery);
       var index=cells.findIndex(function(cell){return cell.getAttribute('data-media-id')===mediaId;});
       if(index>=0){
         var flickity=window.Flickity&&typeof window.Flickity.data==='function'&&window.Flickity.data(gallery);
         if(flickity&&typeof flickity.select==='function')flickity.select(index);
         else if(cells[index].scrollIntoView)cells[index].scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});
         requestRepaint();
         return;
       }
       var image=button.querySelector('img');
       var kind=frameKey(image&&image.alt);
       var frameButton=kind&&each(article,'.ph-v2__option--frame[data-ph-v2-value]').find(function(b){
         return frameKey(b.getAttribute('data-ph-v2-value'))===kind;
       });
       if(frameButton&&!frameButton.disabled){
         pendingMediaId=mediaId;
         frameButton.click();
         requestRepaint();
         window.setTimeout(function(){
           if(pendingMediaId===mediaId){pendingMediaId=null;openOriginalPreview(button);}
         },900);
         return;
       }
       openOriginalPreview(button);
     });
   });
   [galleryArea,article.querySelector('.ctm_product-gallery')].filter(Boolean)
     .forEach(function(root){
       root.addEventListener('load',requestRepaint,true);
       new MutationObserver(function(mutations){
         if(mutations.some(function(m){
           return m.type==='childList'||(m.type==='attributes'&&
             ((m.target.classList&&m.target.classList.contains('product-gallery__item'))||
              m.target.tagName==='IMG'));
         }))requestRepaint();
       }).observe(root,{subtree:true,childList:true,attributes:true,
         attributeFilter:['class','src','srcset','style','hidden']});
     });
   // Re-anchor when the dynamic frame starts, or the main image changes size.
   new MutationObserver(requestRepaint).observe(article,{attributes:true,attributeFilter:['class']});
   if(window.ResizeObserver){
     var ro=new ResizeObserver(requestRepaint);
     var mainForRail=article.querySelector('.ctm_product_gallery_main');
     var originalForRail=article.querySelector('.ctm_product-gallery');
     if(mainForRail)ro.observe(mainForRail);
     if(originalForRail)ro.observe(originalForRail);
   }
   if(desktop.addEventListener)desktop.addEventListener('change',requestRepaint);
   else if(desktop.addListener)desktop.addListener(requestRepaint);
   window.addEventListener('resize',requestRepaint,{passive:true});
   // A cached media image can complete before the observer is attached.
   // One post-load position check closes that initial-layout gap.
   window.addEventListener('load',requestRepaint,{once:true});
   requestRepaint();
 }
 function initModal(article){
   var details=article.querySelector('details[data-ph-v6-size-guide]');
   if(!details||details.dataset.phV7Modal==='1'||typeof HTMLDialogElement==='undefined'||typeof HTMLDialogElement.prototype.showModal!=='function')return;
   var summary=details.querySelector('summary');
   var originalImage=details.querySelector('img[data-ph-v6-chart]');
   if(!summary||!originalImage)return;
   details.dataset.phV7Modal='1';
   var dialog=document.createElement('dialog');
   dialog.className='ph-v7__size-modal';
   dialog.dir=document.documentElement.lang.toLowerCase().indexOf('he')===0?'rtl':'ltr';
   var header=document.createElement('div');header.className='ph-v7__size-modal-header';
   var heading=document.createElement('h2');heading.className='ph-v7__size-modal-heading';
   heading.textContent=(details.querySelector('.ph-v6__size-guide-summary')||summary).textContent.trim();
   heading.id='ph-v7-chart-heading-'+article.id.replace(/[^a-zA-Z0-9-]/g,'');
   dialog.setAttribute('aria-labelledby',heading.id);
   var close=document.createElement('button');close.className='ph-v7__size-modal-close';close.type='button';close.textContent='×';
   close.setAttribute('aria-label',dialog.dir==='rtl'?'סגירה':'Close');
   header.appendChild(heading);header.appendChild(close);
   var content=document.createElement('div');content.className='ph-v7__size-modal-content';
   var figure=document.createElement('figure');
   var picture=originalImage.cloneNode(true);
   picture.removeAttribute('data-ph-v6-chart');picture.removeAttribute('data-ph-v6-init');
   picture.removeAttribute('loading');picture.removeAttribute('data-ph-v6-tried-fallback');
   picture.addEventListener('error',function(){
     if(picture.dataset.phV7Backup==='1')return;
     picture.dataset.phV7Backup='1';
     var fallback=originalImage.getAttribute('data-ph-v6-fallback');if(fallback)picture.src=fallback;
   });
   figure.appendChild(picture);
   var caption=details.querySelector('figcaption');if(caption)figure.appendChild(caption.cloneNode(true));
   content.appendChild(figure);dialog.appendChild(header);dialog.appendChild(content);
   document.body.appendChild(dialog);
   summary.addEventListener('click',function(event){
     event.preventDefault();
     if(dialog.open)return;
     picture.dataset.phV7Backup='0';
     picture.src=originalImage.currentSrc||originalImage.src;
     dialog.showModal();
     close.focus();
   });
   close.addEventListener('click',function(){dialog.close()});
   dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close()});
   dialog.addEventListener('close',function(){summary.focus()});
 }
 function mount(){
   if(!document.body||!document.body.classList.contains('ph-v7')||!document.body.classList.contains('template-product')||document.body.classList.contains('template-product-portfolio'))return;
   each(document,'article.product.page-section').forEach(function(article){initRail(article);initModal(article)});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
 document.addEventListener('shopify:section:load',mount);
}());

/* PhotoHouse V11 media controller — single source of first-viewport media
 * centering and native-image zoom placement. Independent of the screenshot's
 * resolution, locale direction and product media type; no Shopify data writes. */
(function(){
 'use strict';
 var minimumGap=24,inset=16;
 function calculateMargin(viewport,articleTop,mediaTop,mediaHeight,currentMargin){
   if(![viewport,articleTop,mediaTop,mediaHeight,currentMargin].every(Number.isFinite)||
      viewport-articleTop<230||mediaHeight<80)return null;
   var gap=Math.max(minimumGap,(viewport-articleTop-mediaHeight)/2);
   return Math.max(0,Math.min(viewport,currentMargin+articleTop+gap-mediaTop));
 }
 function rect(el){if(!el||!el.getBoundingClientRect)return null;var r=el.getBoundingClientRect();return r.width>=60&&r.height>=60?r:null;}
 function media(article,gallery){
   var found=window.phV7VisiblePhoto&&window.phV7VisiblePhoto(article);
   return found&&found.rect||null;
 }
 function zoom(article,gallery){
   // The original Shopify zoom click remains the action authority. Only
   // the VISIBLE control is positioned relative to the full gallery, using
   // the same painted photo bounds as the thumbnail rail.
   var main=gallery.querySelector('.ctm_product_gallery_main');
   if(!main)return;
   var visual=window.phV7VisiblePhoto&&window.phV7VisiblePhoto(article);
   var overlay=article.querySelector('[data-ph-v7-visual-zoom]');
   var original=article.querySelector('.ctm_product-gallery .product__image-zoom')||
     article.querySelector('.filter_product_gallery .product__image-zoom');
   if(!original||!visual||window.innerWidth<1024){
     if(overlay)overlay.hidden=true;
     article.classList.remove('ph-v7--visual-zoom-owned');
     return;
   }
   if(!overlay){
     var icon=original.querySelector('svg');
     if(!icon)return;
     overlay=document.createElement('button');
     overlay.type='button';
     overlay.className='ph-v7__visual-zoom';
     overlay.setAttribute('data-ph-v7-visual-zoom','');
     overlay.setAttribute('aria-label',/^he/i.test(document.documentElement.lang||'')?
       'הגדלת תמונת המוצר':'Enlarge product image');
     overlay.appendChild(icon.cloneNode(true));
     overlay.addEventListener('click',function(){
       var current=window.phV7VisiblePhoto&&window.phV7VisiblePhoto(article);
       if(!current||current.stage)return;
       var mediaId=String(current.mediaId||'').replace(/[^0-9]/g,'');
       var selected=mediaId&&article.querySelector(
         '.ctm_product-gallery .product-gallery__item[data-media-id="'+mediaId+'"] .product__image-zoom');
       var originalZoom=selected||article.querySelector('.ctm_product-gallery .product__image-zoom')||
         article.querySelector('.filter_product_gallery .product__image-zoom');
       if(originalZoom)originalZoom.click();
     });
   }
   article.classList.add('ph-v7--visual-zoom-owned');
   if(visual.stage){overlay.hidden=true;return;}
   var outer=gallery.getBoundingClientRect(),photo=visual.rect;
   if(outer.width<80||outer.height<80||photo.width<65||photo.height<65){
     overlay.hidden=true;return;
   }
   if(window.getComputedStyle(gallery).position==='static')
     gallery.style.setProperty('position','relative','important');
   if(overlay.parentElement!==gallery)gallery.appendChild(overlay);
   var x=Math.max(4,Math.min(outer.width-40,photo.left-outer.left+inset));
   var y=Math.max(4,Math.min(outer.height-40,photo.top-outer.top+inset));
   var left=Math.round(x)+'px',top=Math.round(y)+'px';
   if(overlay.style.getPropertyValue('left')!==left)
     overlay.style.setProperty('left',left,'important');
   if(overlay.style.getPropertyValue('top')!==top)
     overlay.style.setProperty('top',top,'important');
   if(overlay.hidden)overlay.hidden=false;
 }
 function mount(article){
   if(article.dataset.phMediaGeometryMounted==='1')return;
   var gallery=article.querySelector(':scope > .product__gallery')||article.querySelector('.product__gallery');
   if(!gallery)return;
   article.dataset.phMediaGeometryMounted='1';
   var queued=false;
   function sync(){
     queued=false;if(!article.isConnected)return;
     if(window.innerWidth<1024)gallery.style.removeProperty('--ph-v11-gallery-margin-top');
     else if((window.scrollY||window.pageYOffset||0)<16){
       var box=media(article,gallery);
       if(box){
         var viewport=window.innerHeight||document.documentElement.clientHeight;
         // Use the actual lower edge of the merchant's two-row header,
         // rather than a layout wrapper that can include extra padding.
         var nav=document.querySelector('.ph-v3__topbar');
         var header=nav&&nav.getBoundingClientRect();
         var top=(header&&header.bottom>0&&header.bottom<viewport*.6)
           ? header.bottom : Math.max(0,article.getBoundingClientRect().top);
         var current=parseFloat(window.getComputedStyle(gallery).marginTop)||0;
         var target=calculateMargin(viewport,top,box.top,box.height,current);
         if(target!==null&&Math.abs(target-current)>1.5)
           gallery.style.setProperty('--ph-v11-gallery-margin-top',Math.round(target)+'px');
       }
     }
     zoom(article,gallery);
   }
   function schedule(){if(queued)return;queued=true;window.requestAnimationFrame(sync);}
   gallery.addEventListener('load',schedule,true);
   article.addEventListener('change',schedule,true);
   article.addEventListener('click',function(e){if(e.target.closest('.ph-v7__thumb,.ph-v2__option,.product__image-zoom'))schedule();},true);
   if(window.MutationObserver){
     new MutationObserver(function(ms){
       if(ms.some(function(m){return m.type==='childList'||['src','srcset','class','hidden'].indexOf(m.attributeName)>=0;}))schedule();
     }).observe(gallery,{subtree:true,childList:true,attributes:true,attributeFilter:['src','srcset','class','hidden']});
     new MutationObserver(schedule).observe(article,{attributes:true,attributeFilter:['class']});
   }
   if(window.ResizeObserver){
     var ro=new ResizeObserver(schedule);
     ro.observe(gallery);
     var main=gallery.querySelector('.ctm_product_gallery_main');if(main)ro.observe(main);
   }
   window.addEventListener('resize',schedule,{passive:true});
   window.addEventListener('load',schedule,{once:true});
   schedule();
 }
 function start(){
   if(!document.body||!document.body.classList.contains('ph-v1')||
      !document.body.classList.contains('template-product')||
      document.body.classList.contains('template-product-portfolio'))return;
   Array.prototype.slice.call(document.querySelectorAll('article.product.page-section')).forEach(mount);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',start);
}());
